import React from "react";
import './About.css'; // Import the plain CSS file

// About Component for QuickFit - Using Plain CSS
const About = () => {
  return (
    // Apply styles using plain CSS class names
    <div className="aboutPage">
      <div className="container">
        {/* Header Section */}
        <div className="header">
          <h1 className="mainHeading">
            About QuickFit
          </h1>
          <p className="subHeading">
            Your Personal Style Revolution
          </p>
        </div>

        {/* Content Sections Container */}
        <div className="contentSections">
          {/* Mission Section */}
          <section className="section">
            <h2 className="sectionHeading">
              Our Mission
            </h2>
            <p className="sectionText">
              We empower everyone to discover and express their unique style with confidence and ease. Fashion should be personal, accessible, and fun — not overwhelming. QuickFit is here to make that a reality.
            </p>
          </section>

          {/* Differentiation Section */}
          <section className="section">
            <h2 className="sectionHeading">
              What Makes QuickFit Different?
            </h2>
            <p className="sectionText">
              Tired of endless scrolling and guessing what fits? QuickFit simplifies your search with AI-powered outfit suggestions tailored to your style, size, and wardrobe. We personalize every recommendation — so you find what fits and flatters, faster.
            </p>
            <p className="sectionText">
              From curated looks to virtual try-ons (coming soon!), QuickFit helps you shop smarter — all in one place.
            </p>
          </section>

          {/* Coming Soon Section with Signup */}
          {/* Combine multiple classes into a single string */}
          <section className="section comingSoonSection">
            <h2 className="comingSoonHeading">
              Something Amazing is Coming Soon!
            </h2>
            <p className="comingSoonText">
              We’re putting the finishing touches on QuickFit. Sign up below to get early access and exclusive launch perks!
            </p>

            {/* Signup Form */}
            <form
              action="https://formspree.io/f/your-form-id" // Remember to replace with your actual Formspree ID
              method="POST"
              className="signupForm"
            >
              {/* Screen reader only label - still good practice */}
              <label htmlFor="email-address" className="srOnly">Email address</label>
              <input
                id="email-address"
                type="email"
                name="email"
                autoComplete="email"
                placeholder="Enter your email address"
                required
                className="emailInput" // Apply input styles
              />
              <button
                type="submit"
                className="submitButton" // Apply button styles
              >
                Notify Me
              </button>
            </form>

            <p className="privacyText">
              We respect your privacy. No spam, ever.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
